export interface MeetingFilterOptions {
    floors: string[];
    layoutTypes: string[];
    groups: number[];
    searchText: string;
    hasSent: 'all' | 'yes' | 'no';
    hasMeetingDate: 'all' | 'yes' | 'no';
    hasConfirmed: 'all' | 'yes' | 'no';
    hasReminded: 'all' | 'yes' | 'no';
}

export class MeetingFilterOptions {
    static empty(): MeetingFilterOptions {
        return {
            floors: [],
            layoutTypes: [],
            groups: [],
            searchText: '',
            hasSent: 'all',
            hasMeetingDate: 'all',
            hasConfirmed: 'all',
            hasReminded: 'all',
        };
    }
}

export { default } from './MeetingsFilter';
